const React = require('react');
const { submitRecommendationFeedback } = require('@managers/fieldManager');

const RecommendationFeedback = ({
  value,
  onChange,
  t,
  recommendationAmount,
  weekRange,
  recommendationMode,
  fieldId,
  dateGenerated,
  localMidnightWeekStart,
}) => {
  const [showThanks, setShowThanks] = React.useState(false);

  // Auto-hide thanks message after 4 seconds
  React.useEffect(() => {
    if (showThanks) {
      const timer = setTimeout(() => {
        setShowThanks(false);
      }, 4000); // 4 seconds

      // Cleanup timer if component unmounts or showThanks changes
      return () => clearTimeout(timer);
    }
  }, [showThanks]);

  const handleClick = async (val) => {
    onChange(val);
    setShowThanks(true);

    submitRecommendationFeedback(
      val,
      fieldId,
      dateGenerated,
      localMidnightWeekStart,
      recommendationAmount,
      weekRange,
      recommendationMode,
    );
  };

  return (
    <div className={`feedback-row-figma${showThanks ? ' thanks' : ''}`}>
      {showThanks ? (
        <span className='feedback-thanks-figma'>
          {t('new_planner_feedback_thanks')}
        </span>
      ) : (
        <>
          <span className='feedback-question-figma'>
            {t('recommendation_useful')}
          </span>
          <div className='feedback-btns-figma'>
            <button
              className={`feedback-btn-figma${value === 'no' ? ' selected' : ''}`}
              onClick={() => handleClick('no')}
              aria-pressed={value === 'no'}
              aria-label={t('no')}
              type='button'
            >
              <img
                src={require('images/icons/dislike_button.svg')}
                alt={t('no')}
                width={14}
                height={14}
                style={{ marginRight: 2 }}
              />
              <span className='feedback-btn-label-figma'>{t('no')}</span>
            </button>
            <button
              className={`feedback-btn-figma${value === 'yes' ? ' selected' : ''}`}
              onClick={() => handleClick('yes')}
              aria-pressed={value === 'yes'}
              aria-label={t('yes')}
              type='button'
            >
              <img
                src={require('images/icons/like_button.svg')}
                alt={t('yes')}
                width={14}
                height={14}
                style={{ marginRight: 2 }}
              />
              <span className='feedback-btn-label-figma'>{t('yes')}</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

module.exports = RecommendationFeedback;
